import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Checkbox } from "cxa-components";
import FormField from "./FormField";

const renderReadOnlyField = props => (
  <Fragment>
    <Checkbox {...props} />
    {props.helpText && props.helpText != "#void help text#" && (
      <div className="help-text">{props.helpText}</div>
    )}
  </Fragment>
);

const CheckboxField = ({ value, ...props }) => (
  <FormField
    component={renderReadOnlyField}
    type="checkbox"
    normalize={value => !!value}
    {...props}
  />
);

CheckboxField.propTypes = {
  value: PropTypes.bool,
};

export default CheckboxField;



// WEBPACK FOOTER //
// ./components/common/form-field/CheckboxField.js